




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { UserStateModule } from '@/store';
import { CONSTANTS } from '@/core';
import { FavoriteMyListModel, CommentModel } from '../../type';
import { ExtendedCommentList } from '../page/Activity.vue';

@Component<ActivityContainer>({})
export default class ActivityContainer extends Vue {
  // PROPS
  @Prop({ type: Array, default: () => [] })
  comments!: ExtendedCommentList[];

  // MUTATIONS
  get getUserName() {
    return UserStateModule.getUserName;
  }
  get memberInfo() {
    return UserStateModule.selfUser;
  }
  get getAvaterSrc() {
    return UserStateModule.getSmallImage;
  }

  // METHODS
  getWitchPost(extendedComment: ExtendedCommentList) {
    switch (extendedComment.type) {
      case 'POSTED':
        return 'あなたの投稿';
      case 'FAV':
        return 'あなたがいいね！した投稿';
    }
  }
}
